import { Component } from '@angular/core';
import { CustomSocketComponent } from '../custom-socket/custom-socket.component';

@Component({
  selector: 'app-default-input-socket',
  imports: [],
  template: ``,
  styleUrl: './default-input-socket.component.scss',
})
export class DefaultInputSocketComponent extends CustomSocketComponent {}
